import { useState } from 'react';
import useI18n from 'src/modules/translations/hooks/useI18n';
function getInitialStep(value) {
    return value?.community ? 'examLevel' : 'community';
}
export default function useSelectionFlow(initialValue) {
    const { translate } = useI18n();
    const [step, setStep] = useState(() => getInitialStep(initialValue));
    const [draft, setDraft] = useState(initialValue);
    const selectCommunity = (community) => {
        setDraft({ community });
        setStep('examLevel');
    };
    const goBackToCommunity = () => {
        setStep('community');
    };
    const selectExamLevel = (examLevel, onChange) => {
        if (!draft?.community) {
            return;
        }
        onChange({ community: draft.community, examLevel });
    };
    const title = step === 'community'
        ? translate('Select Exam Community')
        : translate('Select Exam Level');
    return {
        step,
        draft,
        title,
        selectCommunity,
        goBackToCommunity,
        selectExamLevel,
    };
}
